/* React hooks */
import {useEffect, useState} from "react";
/* Routing */
import {useNavigate, useParams} from "react-router-dom";
/* Contexts */
import useData from "../../../hooks/useData";
/* Components */
import FormEmails from "../../../forms/admin/FormEmails";
import Header from "../../../components/common/Header";
import Missing from "../../Missing";
import {getEmailInfos} from "../../../api/admin/emailReq";
import useAuth from "../../../hooks/useAuth";
import TiptapView from "../../../components/common/input-layout/tiptap/TiptapView";
import Icon from "../../../components/common/Icon";


export default function ViewEmailInfos() {
    const { id } = useParams();
    const { emailInfos, setEmailInfos } = useData();
    const { auth } = useAuth();
    const token = auth.token;
    const [ showModal, setShowModal ] = useState(false);
    const navigate = useNavigate();

    const apiEmailInfos = async () => {
        const response = await getEmailInfos(token, id);
        setEmailInfos(response);
    }

    const handleRemoveInfosModal = (e) => {
        if (e.target.classList.contains("email-infos")) {
            setShowModal(false)
        }
    };

    useEffect(() => {
        apiEmailInfos();
    }, [id]);

    const handleEmailForm = () => {
        setShowModal(true)
    };

    return (
        <main>
            { emailInfos?.error &&
                <Missing />
            }
            { !emailInfos.error &&
                <>
                    <Header parent="Emails"
                            location={(id !== 0) && "Modification d'un email "}
                            locationComp={`${emailInfos.subject ? emailInfos?.subject : ""}`}
                            slug="/admin/emails"
                    />
                    {showModal &&
                        <div className="modal email-infos">
                            <FormEmails apiEmailInfos={apiEmailInfos} setShowModal={setShowModal} legend="Modification d'un email"/>
                        </div>
                    }
                    <fieldset>
                        <Icon source="fa fa-at" span="Informations d'un email"/>
                        <div className="form-input">
                            <label>Description</label>
                            <span>{emailInfos?.description}</span>
                        </div>
                        <div className="form-input">
                            <label>Sujet</label>
                            <span>{emailInfos?.subject}</span>
                        </div>
                        <div className="form-input html-textarea view">
                            <label>Contenu HTML</label>
                            <TiptapView content={emailInfos?.body}/>
                        </div>
                        <div className="buttons-container">
                            <button onClick={() => navigate(-1)}><i className="fa fa-arrow-left"></i> <span>Retour</span></button>
                            <button className="red-button" onClick={handleEmailForm}><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>
                        </div>
                    </fieldset>
                </>
            }
        </main>
    )
}